import React, { Component } from 'react';
import {
    Link
} from 'react-router-dom';

export interface PropsFromState {
    content: string
    photos: string[]
}

export interface PropsFromDispatch {
    updateContent: (content: string) => void
    submitPost: () => void
}

class Composer extends Component<PropsFromState & PropsFromDispatch, any> {

    constructor(props: PropsFromState & PropsFromDispatch) {
        super(props)

        this.handleContentChange = this.handleContentChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    public handleContentChange(event: React.FormEvent<HTMLTextAreaElement>) {
        event.preventDefault();
        this.props.updateContent(event.currentTarget.value as string)
    }

    public handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        this.props.submitPost()
    }

    render() {

        const imgProxy = "http://165.227.131.254:8080/160x160/"

        const photos = this.props.photos.map((photo: string) => {
            const photoURL = imgProxy + photo
            return (
                <img key={photoURL} src={photoURL} />
            )
        })

        return (
            <div>

                {photos}

                <form onSubmit={this.handleSubmit}>
                    <textarea
                        className="input-reset db pa2"
                        onChange={this.handleContentChange}
                        placeholder="Write something nice"
                        value={this.props.content}
                    ></textarea>

                    <Link
                        className="pa1 ma1 db"
                        to="/composer/media/gallery">Add Photo</Link>

                    <input
                        className="input-reset db pa2 ma1"
                        type="submit"
                        value="Post"
                    />
                </form>
            </div>
        );
    }

}

export default Composer;
